import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { categoryActions as actions } from '../../actions';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import '../../content/css/PageFilterControl.css';

class PageThemeFilterControl extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        if (this.props.themePackages.length == 0) this.props.requestThemePackages();
    }

    handleThemeChange = (eventKey, event) => {
        if (eventKey == 0) return;
        this.props.onChange(eventKey);
    }

    getThemes() {
        return this.props.themePackages.map((theme, i) => {
            return <MenuItem key={theme.id} eventKey={theme.id}>{theme.name}</MenuItem>;
        });
    }

    render() {
        return (
            <div className="filter-theme">
                <DropdownButton title={"Change theme"} id={`dropdown-basic`} onSelect={this.handleThemeChange} pullRight>
                    <MenuItem key={0} eventKey={0} active>{this.props.themeName}</MenuItem>
                    <MenuItem divider />
                    {this.getThemes()}
                </DropdownButton>
            </div>
        );
    }
}

export default connect(
    state => state.category,
    dispatch => bindActionCreators(actions, dispatch)
)(PageThemeFilterControl);


// WEBPACK FOOTER //
// ./src/components/DocumentViewer/PageThemeFilterControl.js